<span [class]="classes()"><ng-content /></span>
